// services/categoryService.js
import axios from "axios";
import configuration from "@/utils/configuration";

export const categoryService = {
  // ---------- For General user -------------

  getAllCategories(params) {
    return axios.get(`${configuration.backUrl}/category/management`, {
      withCredentials:true,
      params:params
    });
  },
  fetchCategoryList() {
    return axios.get(`${configuration.backUrl}/category/lists`, {
    });
  },
  fetchRecommendCourse() {
    return axios.get(`${configuration.backUrl}/category/for-me`, {
      withCredentials: true,
    });
  },
  fetchHotCategory() {
    return axios.get(`${configuration.backUrl}/category/recommended`, {
    });
  },

  fetchCategories() {
    return axios.get(`${configuration.backUrl}/category`, {
      withCredentials: true,
    });
  },

  fetchCategoryById(categoryId) {
    return axios.get(`${configuration.backUrl}/category/search`, {
      params: { category_id: categoryId },
    });
  },

  postCategory(payload) {
    return axios.post(`${configuration.backUrl}/category`, payload, {
      withCredentials: true,
    });
  },

  patchCategory(categoryId, payload) {
    return axios.patch(`${configuration.backUrl}/category`, payload, {
      withCredentials: true,
      params: { category_id: categoryId },
    });
  },

  deleteCategory(categoryId) {
    return axios.delete(`${configuration.backUrl}/category`, {
      withCredentials: true,
      params: { category_id: categoryId },
    });
  },
   patchCategoryImg({categoryId, payload}) {
    return axios.patch(`${configuration.backUrl}/category/category-image`, payload, {
      withCredentials: true,
      params: { category_id: categoryId },
    });
  },
  deleteCategoryImg(categoryId) {
    return axios.delete(`${configuration.backUrl}/category/category-image`, {
      withCredentials: true,
      params: { category_id: categoryId },
    });
  },

  patchCategoryStatus(categoryId, status) {
    return axios.patch(
      `${configuration.backUrl}/category/update-status`,null,
      {
        withCredentials: true,
        params: {
          category_id: categoryId,
          is_active: status,
        },
      }
    );
  },
};
